export const detailPageCardSx = {
  border: '1px solid #DFE5F6',
  borderRadius: '24px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 8px 24px rgba(31, 46, 85, 0.06)',
  p: { xs: 2.5, sm: 4 },
};

export const detailFieldSx = {
  minHeight: 74,
  border: '1px solid #DFE5F6',
  borderRadius: '16px',
  backgroundColor: '#FFFFFF',
  px: 2,
  py: 1.75,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const detailSectionTitleSx = {
  fontSize: 18,
  lineHeight: '28px',
  letterSpacing: '0px',
  fontWeight: 600,
  color: '#1C1B1F',
  mb: 2.5,
};

export const detailLabelSx = {
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  fontWeight: 600,
  color: '#1C1B1F',
  mb: 0.5,
};

export const detailValueSx = {
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#1C1B1F',
  wordBreak: 'break-word',
};
